import React from "react";
import { Button } from "reactstrap";
import { useStepperContext } from "./StepperContext";
import {
  faArrowLeft,
  faArrowRight,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const StepperNavigation = ({
  onComplete,
  disableNext = false,
  nextButtonText = "Next",
  backButtonText = "Back",
  completeButtonText = "Complete",
}) => {
  const { isFirstStep, isLastStep, goToNextStep, goToPrevStep } =
    useStepperContext();

  const handleNext = () => {
    if (isLastStep && onComplete) {
      onComplete();
    } else {
      goToNextStep();
    }
  };

  return (
    <div className="d-flex justify-content-between mt-4 mb-3">
      <div>
        {!isFirstStep && (
          <Button color="secondary" outline onClick={goToPrevStep}>
            <FontAwesomeIcon icon={faArrowLeft} className="me-2 mr-2" />
            {backButtonText}
          </Button>
        )}
      </div>

      <div>
        <Button
          color={isLastStep ? "success" : "primary"}
          onClick={handleNext}
          disabled={disableNext}
        >
          {isLastStep ? (
            <>
              {completeButtonText}
              <FontAwesomeIcon icon={faCheck} className="ms-2 ml-2" />
            </>
          ) : (
            <>
              {nextButtonText}
              <FontAwesomeIcon icon={faArrowRight} className="ms-2 ml-2" />
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

export default StepperNavigation;
